import { Routes } from '@angular/router';
import { Base } from './shared/layouts/base/base';
import { NotFound } from './pages/not-found/not-found';
import segmentationRoutes from './pages/segmentation/segmentation.routes';
import { Auth } from './shared/layouts/auth/auth';
import { authGuard } from './shared/guard/auth.guard';

export const routes: Routes = [
  {
    path: 'login',
    component: Auth,
    children: [
      {
        path: '',
        loadComponent: () => import('./pages/login/login').then((m) => m.Login),
      },
    ],
  },
  {
    path: '',
    component: Base,
    canActivate: [authGuard],
    children: [
      {
        path: '',
        data: { title: 'Accueil' },
        loadComponent: () => import('./pages/home/home').then((m) => m.Home),
      },
      {
        path: 'performance',
        data: { title: 'Performances' },
        loadComponent: () =>
          import('./pages/performances/performances').then(
            (m) => m.Performances,
          ),
      },
      {
        path: 'segmentation',
        children: segmentationRoutes,
      },
      {
        path: 'donnees-brutes',
        data: { title: 'Données brutes' },
        loadComponent: () =>
          import('./pages/raw-data/raw-data').then((m) => m.RawData),
      },
      { path: 'page-non-trouvee', data: { title: 'Page non trouvée' }, component: NotFound },
      { path: '**', redirectTo: '/page-non-trouvee' },
    ],
  },
];
